export default __webpack_public_path__ + "assets/img/error-404.73bb52e.svg";